module.exports = __webpack_public_path__ + "img/materials_analysis_1.c6aac0ea.png";